import { InvoicesPageContent } from '@features/invoices/components/invoices-page-content/InvoicesPageContent';
import { InvoiceAlertsProvider } from '@features/invoices/contexts/alerts/InvoiceAlertsProvider';
import { InvoicesDataProvider } from '@features/invoices/contexts/data/InvoicesDataProvider';
import { InvoicesFilterProvider } from '@features/invoices/contexts/filter/InvoicesFilterProvider';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

const InvoicesPage = React.memo((): React.ReactElement => {
  return (
    <InvoiceAlertsProvider>
      <InvoicesFilterProvider>
        <InvoicesDataProvider>
          <InvoicesPageContent />
          <Outlet />
        </InvoicesDataProvider>
      </InvoicesFilterProvider>
    </InvoiceAlertsProvider>
  );
});

InvoicesPage.displayName = 'InvoicesPage';

export { InvoicesPage };
